import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '../../store/types';

const getActAsId = () => localStorage.getItem('actAsUserId');
const getAuthId = (state: AppState) => state.authReducer.userData.id;

export const selectActingUserId = createSelector(
  [getActAsId, getAuthId],
  (actAsId, authId) => actAsId ?? authId,
);
